// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bik_a bik_x bik_j bik_u bik_bc bik_ql bik_vv"};